import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { stringify } from 'querystring';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.css']
})
export class DestinationsComponent extends BaseCrudComponent {

  	translations:any;
    orders:any;
    drivers:any;
    loadingRequired:any;
    loadingSAP:any;
    processSAP:any;
    status:any;

    lat: number = -2.191332;
    lng: number = -79.565221;
    zoom: number = 8;
    mapType: String;
    marker:any;
    datePipe: any;
    sap_rows:any;
    sap_routes:any;
    sap_status:any;
    today:any;
    momentjs: any = moment;

    f_custom2:any;
    all = false;
    selectedOnes:any;
    toDelete:any;
    isDeleting = false;


  	constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        public mapModal: NgbModal,
      ) {
        super(srv, modalService, storage, router);

        //this.read_url = 'LogisticDestination/All';
        this.read_url = 'LogisticDestination/AllPending';
        this.create_url = 'LogisticDestination/Create';
        this.update_url = 'LogisticDestination/Update';
        this.delete_url = 'LogisticDestination/LogicalDelete';
        this.search_fields = [];
        this.loadingRequired = false;
        this.loadingSAP = false;
        this.processSAP = false;
        this.marker = {};
        this.selectedOnes = [];
        this.toDelete = [];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });

        this.status = [
        	{id:'12', value:'Asignado'},
        	{id:'13', value:'Pendiente'}
        ];

        this.sap_rows = [];
        this.sap_routes = [];
        this.sap_status = [
            //{name:'E', code:'E'},
            {name:'I', code:'I'},
            {name:'P', code:'P'},
            {name:'A', code:'A'}
        ];
    }

    ngOnInit() {
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.today;
        this.f_dateto = this.today;

        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();

                this.loadingSAP = true;
                this.getSapRoutes().subscribe(r => {
                    //console.log(r);
                    this.loadingSAP = false;
                    
                    if( r != false ){
                        this.sap_routes = [];
                        r.forEach(y => {
                            this.sap_routes.push({name: y.description, code: y.code});
                        });
                    }

                    this.getList();
                });
        });
    }

    public getSapRoutes(){
        var par_url = 'LogisticRoute/GetSapRoutes';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
    
    }
    
    getList(){
        var qst = this.read_url;
        
        this.clearData();
        this.loadingList = true;
        this.srv.getCall(qst).subscribe(x => {
            var data = x.data;
            
            this.loadingList = false;
            if(x.status){
                this.rows = x.data;
            }
        });
    }

    getSAPList(){
        var qst = "LogisticDestination/GetSapData2";

        var start = this.momentjs(this.f_datefrom);
        var end = this.momentjs(this.f_dateto);
        
        if( end.isBefore(start) ){
            Swal.fire('Fecha Hasta debe ser mayor o igual a Fecha Desde', '', 'error');
            return;
        }

        this.loadingSAP = true;

        let to:any;
        to = {
            RouteSap: '',
            StartDate: this.f_datefrom,
            EndDate: this.f_dateto,
            Status: ''
        };

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') && (Array.isArray(this.f_custom1)) ){
            to.RouteSap = '';
            let i = 0;
            this.f_custom1.forEach(r => {
                if( i > 0 ){
                    to.RouteSap += ';';
                }
                
                to.RouteSap += r.code;
                i++;
            });
        }

        if( (this.f_custom2 != null) && (this.f_custom2 != 'null') && (Array.isArray(this.f_custom2)) ){
            to.Status = '';
            let i = 0;
            this.f_custom2.forEach(r => {
                if( i > 0 ){
                    to.Status += ';';
                }
                
                to.Status += r.code;
                i++;
            });
        }

        this.srv.postCall(qst, to).subscribe(x => {
            var data = x.data;
            
            this.loadingSAP = false;
            if(x.status){
                let tmp = [];

                data.forEach(element => {
                    //this.sap_rows.push(this.mergeList(element));
                    tmp.push(this.mergeList(element));
                });

                //reset filters
                this.f_datefrom = this.today;
                this.f_dateto = this.today;
                this.f_custom1 = null;
                this.f_custom2 = null;

                this.sap_rows = tmp;
                Swal.fire(data.length+' Registros descargados de SAP', '', 'success');
            }else{
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    mergeList(row: any){
        let obj: {};
        return obj = {
            'clientName':row.clienT_NAME,
            'statusId':row.statuS_ID,
            'userPc':row.useR_PC,
            'invoiceNumber':row.invoicenumber,
            'deliveryNumber':row.deliverY_NUMBER,
            'package':row.pack,
            'routeSap':row.routE_SAP, 
            'quantity':row.quantity,
            'weight':row.weight,
            'volume':row.volume, 
            'dispatchPoint':row.dispatcH_POINT,
            'guideNumber':row.guidE_NUMBER,
            'orderNumber':row.ordeR_NUMBER,
            'transport':row.transport,
            'province':row.province,
            'recipientCity':row.recipienT_CITY,
            'recipientAddress':row.recipienT_ADDRESS,
            'recipientPhone':row.recipienT_PHONE,
            'recipientCode':row.recipienT_CODE,
            'parish':row.parish,
            'registerType':row.registeR_TYPE,
            'itemName':row.iteM_NAME,
            'code':row.code,
            'coordinate':row.coordinate,
            'date':row.datE_DOC,
            'pickingPrintDate':row.fE_IMP_PICK+"T"+row.hoR_IMP_PICK.split("T")[1],
            'labelPrintDate':row.fE_IMP_LABEL+"T"+row.hoR_IMP_LABEL.split("T")[1],
            'wtInitial' : row.wT_INITIAL.split("T")[1],
            'wtFinal' : row.wT_FINAL.split("T")[1],
            'ip':row.ip,
            'type':row.type,
            'sel': false,
            'saleS_GROUP_CODE': row.saleS_GROUP_CODE,
            'saleS_GROUP_NAME': row.saleS_GROUP_NAME
        };
        
    }

    public getFiltersData(){
        var par_url = 'SystemParameter/GetByName/DOC_TYPE';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    openCreateModal(content:any){
        this.c_obj = {};
        this.mapType="c";//create
        super.openCreateModal(content);
        /*this.loadingRequired = true;
        this.getFiltersData().subscribe(x => {
            this.loadingRequired = false;
            if(x != false){
                if( Array.isArray(x) ){
                    x.forEach(i => {
                        this.c_obj.permList.push(i);
                    });
                }
            }
        });*/
    }

    openUpdateModal(content:any, obj:any){
        //this.u_obj = obj;
        this.u_obj = this.castingObj(obj);
        this.mapType = "u";//update
        super.openCreateModalLG(content);
        this.marker = {"name":"", "lat":this.u_obj.lat, "lng":this.u_obj.long};
    }
    

    castingObj(obj: any){
        let WTFinal = this.dataConversion(obj.wtFinal);
        let WTinitial = this.dataConversion(obj.wtInitial);
        let newObj: any 
        //console.log(obj);
        newObj={
            "ClientName":obj.clientName,
            "StatusId":obj.statusId,
            "UserPc":obj.userPc,
            "InvoiceNumber":obj.invoiceNumber,
            "DeliveryNumber":obj.deliveryNumber,
            "OrderNumber":obj.orderNumber,
            "Package":obj.package,
            "RouteSap":obj.routeSap, 
            "Quantity":obj.quantity,
            "Weight":obj.weight,
            "Volume":obj.volume,
            "DispatchPoint":obj.dispatchPoint,
            "GuideNumber":obj.guideNumber,
            "Transport":obj.transport,
            "Province":obj.province,
            "RecipientCity":obj.recipientCity,
            "RecipientAddress":obj.recipientAddress,
            "RecipientPhone":obj.recipientPhone,
            "RecipientCode":obj.recipientCode,
            "Parish":obj.parish,
            "RegisterType":obj.registerType,
            "ItemName":obj.itemName,
            "Code":obj.code,
            "IsReverseLogistic": obj.isReverseLogistic,
            "lat":((obj.coordinate!="") && (obj.coordinate!=null)) ? obj.coordinate.split(";")[0] : "",
            "long":((obj.coordinate!="") && (obj.coordinate!=null)) ? obj.coordinate.split(";")[1] : "",
            "feimppick":(obj.pickingPrintDate != null) ? obj.pickingPrintDate.split("T")[0] : '',
            "hoimppick":(obj.pickingPrintDate != null) ? this.timeConverter(obj.pickingPrintDate.split("T")[1]) : '',
            "feimpetiq":(obj.labelPrintDate != null) ? obj.labelPrintDate.split("T")[0] : '',
            "hoimpetiq":(obj.labelPrintDate != null) ? this.timeConverter(obj.labelPrintDate.split("T")[1]) : '',
            "Date":(obj.date != null) ? obj.date.split("T")[0] : '',
            "WTInitial" : WTinitial,
            "WTFinal" : WTFinal,
            "Ip" : obj.ip,
        };
        if(obj.id>0){
            newObj["id"]=obj.id;
        }
        //console.log(newObj);
        return newObj;
    }

    dataConversion(value :String){
        let arrParam = value.split("T");
        if(arrParam.length==2)
            return this.timeConverter(arrParam[1]);
        else if(arrParam.length==1)
            return this.timeConverter(arrParam[0])
        return value;
    }

    timeConverter(time: String){
        let hour=parseInt(time.split(":")[0]);
        let minute=parseInt(time.split(":")[1]);
        return {"hour":hour,"minute":minute};
    }

    
    public openMapModal(content:any, obj:any){
        this.mapModal.open(content, { centered: true });
        if(obj.lat && obj.long){
            this.marker={"name":"", "lat":obj.lat, "lng":obj.long};
        }
    }

    public placeMarker($event){
        //set selected value into fields
        let fields: any;
        if(this.mapType=="u")
            fields=this.u_obj;
        else
            fields=this.c_obj;
        fields.lat=$event.coords.lat;
        fields.long=$event.coords.lng;
        //selected market put into object to display
        this.marker={"name":"", "lat":$event.coords.lat, "lng":$event.coords.lng};
    }
   

    validateCreateInfo(fields:any){
        let mygroup:any = {};
        mygroup = new FormGroup({
            'ClientName': new FormControl(fields.ClientName, [Validators.required]),
            'StatusId': new FormControl(fields.StatusId, [Validators.required]),
            'UserPc': new FormControl(fields.UserPc, [Validators.required]),
            'InvoiceNumber': new FormControl(fields.InvoiceNumber, [Validators.required]),
            'DeliveryNumber': new FormControl(fields.DeliveryNumber, [Validators.required]),
            'Package': new FormControl(fields.Package, [Validators.required]),
            'RouteSap': new FormControl(fields.RouteSap, [Validators.required]),
            'Quantity': new FormControl(fields.Quantity, [Validators.required]),
            'Weight': new FormControl(fields.Weight, [Validators.required]),
            'Volume': new FormControl(fields.Volume, [Validators.required]),
            'DispatchPoint': new FormControl(fields.DispatchPoint, [Validators.required]),
            'GuideNumber': new FormControl(fields.GuideNumber, [Validators.required]),
            'Transport': new FormControl(fields.Transport, [Validators.required]),
            'Province': new FormControl(fields.Province, [Validators.required]),
            'RecipientCity': new FormControl(fields.RecipientCity, [Validators.required]),
            'RecipientAddress': new FormControl(fields.RecipientAddress, [Validators.required]),
            'RecipientPhone': new FormControl(fields.RecipientPhone, [Validators.required]),
            'RecipientCode': new FormControl(fields.RecipientCode, [Validators.required]),
            'Parish': new FormControl(fields.Parish, [Validators.required]),
            'RegisterType': new FormControl(fields.RegisterType, [Validators.required]),
            'ItemName': new FormControl(fields.ItemName, [Validators.required]),
            'Code': new FormControl(fields.Code, [Validators.required]),
            'lat': new FormControl(fields.lat, [Validators.required]),
            'long': new FormControl(fields.long, [Validators.required]),
            'feimppick': new FormControl(fields.feimppick, [Validators.required]),
            'hoimppick': new FormControl(fields.hoimppick, [Validators.required]),
            'feimpetiq': new FormControl(fields.feimpetiq, [Validators.required]),
            'hoimpetiq': new FormControl(fields.hoimpetiq, [Validators.required]),
            'Date': new FormControl(fields.Date, [Validators.required]),
            'WTInitial': new FormControl(fields.WTInitial, [Validators.required]),
            'WTFinal': new FormControl(fields.WTFinal, [Validators.required]),
        });
        
        return mygroup.valid;
    }

    test(obj:any){
    	console.log(obj);
    }

    public createItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        /*validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }*/
        
        var to:any;
        //to = form;
        to = this.setFormData(form);

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if(x.status){
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire('Creado', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
                //Swal.fire("entro", '', 'success');
            }
        });
    }


    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        /*validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }*/

        var to:any;
        //to = form;
        to = this.setFormData(form);
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

    setFormData(form:any){

        form.WTFinal.hour = (form.WTFinal.hour<10)?"0"+form.WTFinal.hour:form.WTFinal.hour;
        form.WTFinal.minute = (form.WTFinal.minute<10)?"0"+form.WTFinal.minute:form.WTFinal.minute;
        form.WTFinal= form.WTFinal.hour + ":" + form.WTFinal.minute + ":00";
        form.WTInitial.hour = (form.WTInitial.hour<10)?"0"+form.WTInitial.hour:form.WTInitial.hour;
        form.WTInitial.minute = (form.WTInitial.minute<10)?"0"+form.WTInitial.minute:form.WTInitial.minute;
        form.WTInitial= form.WTInitial.hour + ":" + form.WTInitial.minute + ":00";
        /*form.hoimppick.hour = (form.hoimppick.hour<10)?"0"+form.hoimppick.hour:form.hoimppick.hour;
        form.hoimppick.minute = (form.hoimppick.minute<10)?"0"+form.hoimppick.minute:form.hoimppick.minute;
        form.hoimppick= form.hoimppick.hour + ":" + form.hoimppick.minute + ":00.0";
        form.hoimpetiq.hour = (form.hoimpetiq.hour<10)?"0"+form.hoimpetiq.hour:form.hoimpetiq.hour;
        form.hoimpetiq.minute = (form.hoimpetiq.minute<10)?"0"+form.hoimpetiq.minute:form.hoimpetiq.minute;
        form.hoimpetiq= form.hoimpetiq.hour + ":" + form.hoimpetiq.minute + ":00.0";
        form.PickingPrintDate = form.feimppick+"T"+form.hoimppick;*/
        form.Type="MANUAL";
        //form.LabelPrintDate = form.feimpetiq+"T"+form.hoimpetiq;
        form.Coordinate=form.lat + ";" + form.long;
        form.Ip=window.location.origin;

       

        return form;
    }

    addToManual(obj:any){
        let trans = this.translations;
        //console.log(obj);

        Swal.fire({
            title: 'Enviar destinos SAP a detalle?',
            text: '',
            icon: 'success',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: trans.cancel,
            confirmButtonText: 'Enviar',
            preConfirm: () => {
                //this.rows.push(obj);
                var to:any;
                //to = this.setFormData(obj);
                to = this.parseSAP(obj);
                var qst = this.create_url;
                this.isCreating = true;

                this.srv.postCall(qst, to).subscribe(x => {
                    this.isCreating = false;
                    if(x.status){
                        this.getList();
                        //remove from sap list
                        Swal.fire('Exito', '', 'success');
                    }//end success
                    else{
                        Swal.fire(x.message, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

    parseSAP(obj:any){
        let rs:any;
        rs = {};

        rs.ClientName = obj.clientName;
        rs.Coordinate = obj.coordinate;
        rs.DeliveryNumber = obj.deliveryNumber;
        rs.OrderNumber = obj.orderNumber;
        rs.GuideNumber = obj.guideNumber;
        rs.InvoiceNumber = obj.invoiceNumber;
        rs.Ip = obj.ip;
        rs.ItemName = obj.itemName;
        rs.Package = obj.package;
        rs.Province = obj.province;
        rs.Quantity = obj.quantity;
        rs.RecipientAddress = obj.recipientAddress;
        rs.RecipientCity = obj.recipientCity;
        rs.RecipientPhone = obj.recipientPhone;
        rs.Type = 'SAP';
        rs.Volume = obj.volume;
        rs.WTFinal = obj.wtFinal;
        rs.WTInitial = obj.wtInitial;
        rs.Weight = obj.weight;

        rs.RecipientCode = obj.recipientCode;
        rs.RouteSap = obj.routeSap;
        rs.Date = obj.date;
        rs.Transport = obj.transport;
        rs.RegisterType = obj.registerType;
        rs.Parish = obj.parish;
        rs.DispatchPoint = obj.dispatchPoint;

        rs.SalesGroupCode = obj.saleS_GROUP_CODE;
        rs.SalesGroupName = obj.saleS_GROUP_NAME;

        return rs;
    }

    processSAPList(){
        let trans = this.translations;

        Swal.fire({
            title: 'Enviar destinos seleccionados a detalle?',
            text: '',
            icon: 'success',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: trans.cancel,
            confirmButtonText: 'Enviar',
            preConfirm: () => {
                var to = [];
                var counter = 0;
                var ids = [];
                
                this.selectedOnes.forEach(r => {
                    to.push(this.parseSAP(r));
                    ids.push(r.deliveryNumber);
                    counter++;
                });

                if( counter == 0 ){
                    Swal.fire('No hay destinos seleccionados', '', 'error');
                    return;
                }
                
                var qst = 'LogisticDestination/CreateBatch';
                this.processSAP = true;

                this.srv.postCall(qst, to).subscribe(x => {
                    this.processSAP = false;
                    if(x.status){
                        this.getList();

                        //this.getSAPList();
                        let tmp = [];
                        this.sap_rows.forEach(y => {
                            if( ids.indexOf(y.deliveryNumber) < 0 ){
                                tmp.push(y);
                            }
                        });
                        /*console.log(this.sap_rows);
                        console.log(this.selectedOnes);
                        console.log(tmp);*/

                        this.sap_rows = tmp;
                        Swal.fire('Exito', '', 'success');
                    }//end success
                    else{
                        Swal.fire(x.message, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

    removeMultiple(){
        let trans = this.translations;

        Swal.fire({
            title: 'Eliminar destinos seleccionados?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: trans.cancel,
            confirmButtonText: 'Ok',
            preConfirm: () => {
                var to = [];
                var counter = 0;
                
                this.toDelete.forEach(r => {
                    to.push(r.id);
                    counter++;
                });

                if( counter == 0 ){
                    Swal.fire('No hay destinos seleccionados', '', 'error');
                    return;
                }
                
                var qst = 'LogisticDestination/DeleteMassive';
                this.isDeleting = true;

                this.srv.postCall(qst, {Ids: to}).subscribe(x => {
                    this.isDeleting = false;
                    if(x.status){
                        this.getList();
                        Swal.fire('Exito', '', 'success');
                    }//end success
                    else{
                        Swal.fire(x.message, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

}
